// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sort-wrapper-desktop":"FyHbd"};